__turbopack_context__.v({
  "copy": "oaBXIq_copy",
  "endAdornment": "oaBXIq_endAdornment",
  "fieldsSeparator": "oaBXIq_fieldsSeparator",
  "fieldset": "oaBXIq_fieldset",
  "fieldsetContainer": "oaBXIq_fieldsetContainer",
  "formattedNumberInput": "oaBXIq_formattedNumberInput",
  "legend": "oaBXIq_legend",
  "visuallyHidden": "oaBXIq_visuallyHidden",
});
